import { isPropValid, media, styled } from '@migros/msrc-ui-kit';
import { ListStyleType } from '../../helpers';
export const Card = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  ${({
  mode,
  theme
}) => {
  if (mode === ListStyleType.fancy) {
    return `border: 1px solid ${theme.colors.tints.gray[25]};`;
  }
  return `border: 1px solid transparent;`;
}}
  background-color: ${({
  theme
}) => theme.colors.tints.white[100]};
  position: relative;
  padding: ${({
  mode,
  theme
}) => mode === ListStyleType.condensed ? theme.spacings.xsmall : theme.spacings.small};
  border-radius: ${({
  theme
}) => theme.borderItemRadiuses.small};
  overflow: hidden;
  transition: all 150ms ease;
  box-shadow: 0 0 12px rgba(51, 51, 51, 0.1);
  z-index: 1;

  ${({
  mode,
  theme
}) => media.tabletAndUp`
    padding: ${mode === ListStyleType.condensed ? theme.spacingsItem.small : theme.spacingsItem.medium};
  `}
`;